import React from "react";
import styles from "../styles/related-articles.module.css";
import ArticleTile, { Article } from "./article-tile";
import t from "../texts/t";

export type RelatedArticlesProps = {
  className?: string;
  articles: Article[];
  baseUrl: string;
  language?: string;
  condensed?: boolean;
};

export default function RelatedArticles(props: RelatedArticlesProps) {
  const { className, articles, baseUrl, language, condensed } = props;

  if (!articles.length) return null;

  return (
    <div className={className}>
      <h6 className={styles.relatedArticlesTitle}>
        {t("Related articles", language)}
      </h6>
      <ul className={styles.relatedArticlesList}>
        {articles.map((article) => (
          <li key={article.slug} className={styles.relatedArticlesItem}>
            <ArticleTile
              article={article}
              baseUrl={baseUrl}
              condensed={condensed}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
